import { createSlice } from '@reduxjs/toolkit';
import api from '../../api/api';

const initialState = {
    customers: [],
    loading: false,
    error: null
};

export const get_seller_customers = () => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const { data } = await api.get('/seller/customers');
        if (data.success) {
            dispatch(setCustomers(data.customers));
        } else {
            dispatch(setError(data.message || 'Failed to fetch customers'));
        }
        dispatch(setLoading(false));
    } catch (error) {
        console.error('Error fetching customers:', error);
        dispatch(setError(error.response?.data?.message || 'Failed to fetch customers'));
        dispatch(setLoading(false));
    }
};

const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setCustomers: (state, action) => {
            state.customers = action.payload || [];
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        }
    }
});

export const { setCustomers, setLoading, setError } = customerSlice.actions;
export default customerSlice.reducer; 